<w-block-ui [blocked]="blocked" [title]="'processing' | translate" [text]="'please_wait' | translate"></w-block-ui>
<w-step>
  <f-facet name="step-content-top">

        <!-- ========== MAIN PARTIES - SIDE BY SIDE ========== -->
    <div class="row clearfix">
      <div class="column-left">
        <!-- ============ REQUESTING PARTY (CLAIMANT) ============ -->
        <div>
          <w-edit-panel style="height: 24px;">
            <w-section>
              <f-facet name="header" id="headerReqParty"> {{'office.cases.reqParty' | translate}} </f-facet>
            </w-section>
          </w-edit-panel>

          <!-- CLAIMANT LIST -->
          @for (claimant of claimants; track claimant; let i = $index) {
            <w-view-panel [reviewMode]="false" [folded]="!isAccordionOpen('claimant', i)"
              (wFoldedChange)="onAccordionToggle('claimant', i, !$event)">
              <f-facet name="primary-action">
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="toggleEditPartyAtIndex('claimant', i, $event)" [buttonType]="'edit'">
                  </button>
                }
                <!-- CLAIMANT DELETE BUTTON - Only show if not first party or not readonly -->
                @if (!readOnly && canDeleteParty('claimant', i)) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="deletePartyAtIndex('claimant', i)" [buttonType]="'delete'">
                  </button>
                }
              </f-facet>
              <!-- FOLDED VIEW (Collapsed) -->
              <f-facet name="section-folded">
                <w-section>
                  <w-slot>
                    <w-field label="{{'name' | translate}}">
                      {{claimant?.nameClaimant}}
                    </w-field>
                    @if (claimant?.telephoneClaimant) {
                      <w-field label="{{'tel' | translate}}">
                        {{claimant?.telephoneClaimant}}
                      </w-field>
                    }
                    @if (claimant?.emailClaimant) {
                      <w-field label="{{'email' | translate}}">
                        {{claimant?.emailClaimant}}
                      </w-field>
                    }
                  </w-slot>
                </w-section>
              </f-facet>
              <!-- UNFOLDED VIEW (Expanded) -->
              <f-facet name="section-unfolded">
                <!-- ===== VIEW MODE (Read-Only Display) ===== -->
                @if (!isEditingPartyAtIndex('claimant', i)) {
                  <w-section>
                      <w-slot>
                      <w-field label="{{'name' | translate}}">
                        {{claimant?.nameClaimant}}
                      </w-field>
                      @if (officeDetails?.identificationNumberActive === 1 && isMainParty('claimant', i) && claimant?.identificationNumberClaimant) {
                        <w-field label="{{'identificationNumber' | translate}}">
                          {{claimant?.identificationNumberClaimant}}
                        </w-field>
                      }
                      @if (officeDetails?.prefixActive === 1 && isMainParty('claimant', i)) {
                        <w-field
                          label="{{'office.' + office +'.public.case.prefixClaimant' | translate}}">
                          {{claimant?.prefixComplainant}}
                        </w-field>
                      }
                      <w-field label="{{ (i === 0 ? 'office.' + office +'.public.case.requestingPartyAddress' : 'address') | translate }}">
                        {{claimant?.addressClaimant}}
                      </w-field>
                      <w-field label="{{'common.stateOrCountyClaimant' | translate}}">
                        {{claimant?.stateOrCountyClaimant}}
                      </w-field>
                      <w-field label="{{'country' | translate}}">
                        {{claimant?.countryClaimant}}
                      </w-field>
                      <w-field label="{{'tel' | translate}}">
                        {{claimant?.telephoneClaimant}}
                      </w-field>
                      <w-field label="{{'email' | translate}}">
                        {{claimant?.emailClaimant}}
                      </w-field>
                                                                                      @if (isMainParty('claimant', i)) {
                        <w-field label="{{'common.typeClaimant' | translate}}">
                          {{getTypeOfPartyLabel(claimant?.typeClaimant)}}
                        </w-field>
                      }
                      @if (isMainParty('claimant', i) && claimant?.managerComplainant) {
                        <w-field label="{{'common.managerComplainant' | translate}}">
                          {{claimant?.managerComplainant}}
                        </w-field>
                      }
                      @if (isMainParty('claimant', i) && claimant?.typeClaimantOther) {
                        <w-field
                          label="{{'common.typeClaimantOther' | translate}}">
                          {{claimant?.typeClaimantOther}}
                        </w-field>
                      }
                      @if (isMainParty('claimant', i)) {
                        <w-field label="{{'common.genderClaimant' | translate}}">
                          {{getGenderLabel(claimant?.genderClaimant)}}
                        </w-field>
                      }
                    </w-slot>
                    <!-- ADDITIONAL PARTY FIELDS (Index > 0) -->
                    @if (isAdditionalParty('claimant', i)) {
                      <w-slot>
                        @if (claimant?.typeOfParty) {
                          <w-field label="{{'common.typeClaimant' | translate}}">
                            {{getTypeOfPartyLabel(claimant?.typeOfParty)}}
                          </w-field>
                        }
                        @if (claimant?.typeOfPartyOther) {
                          <w-field label="{{'common.typeClaimantOther' | translate}}">
                            {{claimant?.typeOfPartyOther}}
                          </w-field>
                        }
                        <w-field label="{{'common.genderClaimant' | translate}}">
                          {{getGenderLabel(claimant?.gender)}}
                        </w-field>
                      </w-slot>
                    }
                  </w-section>
                }
                <!-- ===== EDIT MODE (Editable Inputs) ===== -->
                @if (isEditingPartyAtIndex('claimant', i)) {
                  <w-section>
                                        <w-slot>
                      <w-input-text [label]="'name' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimants[i].nameClaimant" [name]="'nameClaimant' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'nameClaimant'+i)">
                        @if (validName) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                        @if (ValidationName) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                      <!-- Identification Number (conditional based on office config and main party) -->
                      @if (officeDetails?.identificationNumberActive === 1 && isMainParty('claimant', i)) {
                        <w-input-text
                          [label]="'identificationNumber' | translate" [labelOnTop]="true"
                          [(ngModel)]="claimants[i].identificationNumberClaimant"
                          [name]="'identificationNumberClaimant' + i" [disabled]="readOnly">
                        </w-input-text>
                      }
                      @if (officeDetails?.prefixActive === 1 && isMainParty('claimant', i)) {
                        <w-input-text
                          [label]="'office.' + office +'.public.case.prefixClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="claimants[i].prefixComplainant" [name]="'prefixComplainant' + i" [disabled]="readOnly"
                          (input)="insertData($event, 'prefixComplainant'+i)">
                          @if (validPrefix) {
                            <f-facet name="error">
                              {{'textLengthWarning' | translate: {value: '255'} }}
                            </f-facet>
                          }
                        </w-input-text>
                      }
                      <w-input-text [label]="(i === 0 ? 'office.' + office +'.public.case.requestingPartyAddress' : 'address') | translate" [labelOnTop]="true"
                        [(ngModel)]="claimants[i].addressClaimant" [name]="'addressClaimant' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'addressClaimant'+i)">
                        @if (validAddress) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-input-text [label]="'common.stateOrCountyClaimant' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimants[i].stateOrCountyClaimant" [name]="'stateOrCountyClaimant' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'stateOrCountyClaimant'+i)">
                        @if (validStateOrCounty) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-select-one [label]="'country' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimants[i].countryClaimantCode" [options]="optionsCountries"
                        [disabled]="readOnly">
                      </w-select-one>
                      <w-input-text [label]="'tel' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimants[i].telephoneClaimant" [name]="'telephoneClaimant' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'telephoneClaimant'+i)">
                        @if (validTel) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                        [(ngModel)]="claimants[i].emailClaimant" [name]="'emailClaimant' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'emailClaimant'+i)">
                        @if (validEmail) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <!-- MAIN PARTY TYPE FIELDS (Index 0) -->
                      @if (isMainParty('claimant', i)) {
                        <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                          (change)="selectPartyTypeMain(claimants[i].typeClaimant, 'Claimant', i)"
                          [(ngModel)]="claimants[i].typeClaimant" [options]="typeOfPartyOptions" [disabled]="readOnly">
                        </w-select-one>
                        <!-- DYNAMIC FIELD: Manager (shows when option 2 selected) -->
                        @if (shouldShowManagerMain('claimant', i)) {
                          <w-input-text
                            [label]="'common.managerComplainant' | translate" [labelOnTop]="true"
                            [(ngModel)]="claimants[i].managerComplainant" [name]="'managerComplainant' + i"
                            (input)="insertData($event, 'managerClaimant')">
                            @if (managerComplainantLengthError) {
                              <f-facet name="error">
                                {{'textLengthWarning' | translate: {value: '255'} }}
                              </f-facet>
                            }
                            @if (!validmanagerComplainant) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <!-- DYNAMIC FIELD: Type Other (shows when option 5 selected) -->
                        @if (shouldShowTypeOtherMain('claimant', i)) {
                          <w-input-text
                            [label]="'common.typeClaimantOther' | translate" [labelOnTop]="true"
                            [name]="'typeClaimantOther' + i" [(ngModel)]="claimants[i].typeClaimantOther"
                            (input)="insertData($event, 'typeClaimantOther')">
                            @if (!validTypeClaimantOther) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="claimants[i].genderClaimant" [options]="genderOptions" [disabled]="readOnly">
                        </w-select-one>
                      }
                      <!-- ADDITIONAL PARTY TYPE FIELDS (Index > 0) -->
                      @if (isAdditionalParty('claimant', i)) {
                        <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                          (change)="selectPartyTypeAdditional(claimants[i].typeOfParty, 'claimant', i)"
                          [(ngModel)]="claimants[i].typeOfParty" [options]="typeOfPartyOptions" [disabled]="readOnly">
                        </w-select-one>
                        <!-- DYNAMIC FIELD: Type Other (shows when option 5 selected) -->
                        @if (shouldShowTypeOtherAdditional('claimant', i)) {
                          <w-input-text
                            [label]="'common.typeClaimantOther' | translate" [labelOnTop]="true"
                            [name]="'typeOfPartyOther' + i" [(ngModel)]="claimants[i].typeOfPartyOther"
                            (input)="insertData($event, 'typeOfPartyOther')">
                            @if (!validTypeOfPartyOther) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="claimants[i].gender" [options]="genderOptions" [disabled]="readOnly">
                        </w-select-one>
                      }
                    </w-slot>
                    <w-slot>
                      <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
                        <button w-button [label]="'cancel' | translate" (click)="cancelEditPartyAtIndex('claimant', i)">
                        </button>
                        <button w-button [label]="'save' | translate" [isDefault]="true"
                          (click)="saveEditedPartyAtIndex('claimant', i)">
                        </button>
                      </div>
                    </w-slot>
                  </w-section>
                }
              </f-facet>
            </w-view-panel>
          }

          <!-- ADD CLAIMANT BUTTON -->
          @if (!isAddingParty('claimant') && !readOnly) {
            <button id="addClaimant" w-button [size]="'small'"
              (click)="startAddingParty('claimant')" [buttonType]="'text'" icon-start="add">
              {{'common.addParty' | translate}}
            </button>
          }

          <!-- ADD CLAIMANT FORM -->
          @if (isAddingParty('claimant')) {
            <w-edit-panel [hidden]="false">
              <f-facet name="actions">
                <button w-button (click)="cancelAddingParty('claimant')" style="margin-right: 10px;"> {{'cancel' | translate}} </button>
                <button id="saveClaimant" w-button [isDefault]="true" (click)="saveNewParty('claimant')"> {{'save' |
                translate}} </button>
              </f-facet>
              <w-section>
                <w-slot>
                  <!-- NAME (Required) -->
                  <w-input-text [label]="'name' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.name"
                    name="newNameClaimant" (input)="insertData($event, 'newNameClaimant')">
                    @if (validName) {
                      <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
                    }
                    @if (ValidationName) {
                      <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="(claimants.length === 0 ? 'office.' + office +'.public.case.requestingPartyAddress' : 'address') | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.address"
                    name="newAddressClaimant" (input)="countCharsValNew('address')">
                    @if (validAddress) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'common.stateOrCountyClaimant' | translate" [labelOnTop]="true"
                    [(ngModel)]="newPartyData.stateOrCounty" name="newStateClaimant"
                    (input)="countCharsValNew('stateOrCounty')">
                    @if (validStateOrCounty) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-select-one [label]="'country' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.countryCode"
                    [options]="optionsCountries">
                  </w-select-one>
                  <w-input-text [label]="'tel' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.telephone"
                    name="newTelClaimant">
                  </w-input-text>
                  <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                    [(ngModel)]="newPartyData.email" name="newEmailClaimant" (wKeyup)="onEmailValidNew()">
                    @if (invalidEmailsValidation) {
                      <f-facet name="error">
                        {{'validationEmail' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                  <!-- FOR MAIN PARTY (First Claimant) -->
                  @if (claimants.length === 0) {
                    <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                      (change)="selectPartyTypeForNewMain(newPartyData.typeClaimant, 'Claimant')"
                      [(ngModel)]="newPartyData.typeClaimant" [options]="typeOfPartyOptions">
                    </w-select-one>
                    <!-- DYNAMIC FIELD: Manager (shows when option 2 - Company is selected) -->
                    @if (managerClaimantField) {
                      <w-input-text [label]="'common.managerComplainant' | translate"
                        [labelOnTop]="true" [(ngModel)]="newPartyData.managerComplainant" name="newManagerClaimant"
                        (input)="insertData($event, 'managerClaimant')">
                        @if (managerComplainantLengthError) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                        @if (!validmanagerComplainant) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <!-- DYNAMIC FIELD: Type Other (shows when option 5 - Other is selected) -->
                    @if (displaytypeClaimantOtherField) {
                      <w-input-text [label]="'common.typeClaimantOther' | translate"
                        [labelOnTop]="true" name="newtypeClaimantOther" [(ngModel)]="newPartyData.typeClaimantOther"
                        (input)="insertData($event, 'typeClaimantOther')">
                        @if (!validTypeClaimantOther) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                      [(ngModel)]="newPartyData.genderClaimant" [options]="genderOptions">
                    </w-select-one>
                  }
                  <!-- FOR ADDITIONAL PARTY (Second+ Claimant) -->
                  @if (claimants.length > 0) {
                    <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                      (change)="selectPartyTypeForNewAdditional(newPartyData.typeOfParty)"
                      [(ngModel)]="newPartyData.typeOfParty" [options]="typeOfPartyOptions">
                    </w-select-one>
                    <!-- DYNAMIC FIELD: Type Other (shows when option 5 - Other is selected) -->
                    @if (displayTypeOfPartyOtherField) {
                      <w-input-text [label]="'common.typeClaimantOther' | translate"
                        [labelOnTop]="true" name="newtypeOfPartyOther" [(ngModel)]="newPartyData.typeOfPartyOther"
                        (input)="insertData($event, 'typeOfPartyOther')">
                        @if (!validTypeOfPartyOther) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                      [(ngModel)]="newPartyData.gender" [options]="genderOptions">
                    </w-select-one>
                  }
                </w-slot>
              </w-section>
            </w-edit-panel>
                    }
        </div>
      </div>

      <div class="column-right">
        <!-- ============ RESPONDING PARTY (RESPONDENT) ============ -->
        <div>
          <w-edit-panel style="height: 24px;">
            <w-section>
              <f-facet name="header" id="headerRespParty">
                {{'office.cases.respParty' | translate}}
              </f-facet>
            </w-section>
          </w-edit-panel>

          <!-- RESPONDENT LIST -->
          @for (respondent of respondents; track respondent; let i = $index) {
            <w-view-panel [reviewMode]="false" [folded]="!isAccordionOpen('respondent', i)"
              (wFoldedChange)="onAccordionToggle('respondent', i, !$event)">
              <f-facet name="primary-action">
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="toggleEditPartyAtIndex('respondent', i, $event)" [buttonType]="'edit'">
                  </button>
                }
                <!-- RESPONDENT DELETE BUTTON - Only show if not first party or not readonly -->
                @if (!readOnly && canDeleteParty('respondent', i)) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="deletePartyAtIndex('respondent', i)" [buttonType]="'delete'">
                  </button>
                }
              </f-facet>
              <!-- FOLDED VIEW -->
              <f-facet name="section-folded">
                <w-section>
                  <w-slot>
                    <w-field label="{{'name' | translate}}">
                      {{respondent?.nameRespondent}}
                    </w-field>
                    @if (respondent?.telephoneRespondent) {
                      <w-field label="{{'tel' | translate}}">
                        {{respondent?.telephoneRespondent}}
                      </w-field>
                    }
                    @if (respondent?.emailRespondent) {
                      <w-field label="{{'email' | translate}}">
                        {{respondent?.emailRespondent}}
                      </w-field>
                    }
                  </w-slot>
                </w-section>
              </f-facet>
              <!-- UNFOLDED VIEW -->
              <f-facet name="section-unfolded">
                <!-- VIEW MODE -->
                @if (!isEditingPartyAtIndex('respondent', i)) {
                  <w-section>
                      <w-slot>
                      <w-field label="{{'name' | translate}}">
                        {{respondent?.nameRespondent}}
                      </w-field>
                      @if (officeDetails?.identificationNumberActive === 1 && isMainParty('respondent', i) && respondent?.identificationNumberRespondent) {
                        <w-field label="{{'identificationNumber' | translate}}">
                          {{respondent?.identificationNumberRespondent}}
                        </w-field>
                      }
                      @if (officeDetails?.prefixActive === 1 && isMainParty('respondent', i)) {
                        <w-field
                          label="{{'office.' + office +'.public.case.prefixRespondant' | translate}}">
                          {{respondent?.prefixRespondent}}
                        </w-field>
                      }
                      <w-field label="{{ (i === 0 ? 'office.' + office +'.public.case.respondingPartyAddress' : 'address') | translate }}">
                        {{respondent?.addressRespondent}}
                      </w-field>
                      <w-field label="{{'common.stateOrCountyRespondent' | translate}}">
                        {{respondent?.stateOrCountyRespondent}}
                      </w-field>
                      <w-field label="{{'country' | translate}}">
                        {{respondent?.countryRespondent}}
                      </w-field>
                      <w-field label="{{'tel' | translate}}">
                        {{respondent?.telephoneRespondent}}
                      </w-field>
                      <w-field label="{{'email' | translate}}">
                        {{respondent?.emailRespondent}}
                      </w-field>
                                                                                      @if (isMainParty('respondent', i)) {
                        <w-field label="{{'common.typeClaimant' | translate}}">
                          {{getTypeOfPartyLabel(respondent?.typeRespondent)}}
                        </w-field>
                      }
                      @if (isMainParty('respondent', i) && respondent?.managerRespondent) {
                        <w-field label="{{'common.managerRespondent' | translate}}">
                          {{respondent?.managerRespondent}}
                        </w-field>
                      }
                      @if (isMainParty('respondent', i) && respondent?.typeRespondentOther) {
                        <w-field
                          label="{{'common.typeRespondentOther' | translate}}">
                          {{respondent?.typeRespondentOther}}
                        </w-field>
                      }
                      @if (isMainParty('respondent', i)) {
                        <w-field label="{{'common.genderClaimant' | translate}}">
                          {{getGenderLabel(respondent?.genderRespondent)}}
                        </w-field>
                      }
                    </w-slot>
                    <!-- ADDITIONAL PARTY FIELDS (Index > 0) -->
                    @if (isAdditionalParty('respondent', i)) {
                      <w-slot>
                        @if (respondent?.typeOfParty) {
                          <w-field label="{{'common.typeClaimant' | translate}}">
                            {{getTypeOfPartyLabel(respondent?.typeOfParty)}}
                          </w-field>
                        }
                        @if (respondent?.typeOfPartyOther) {
                          <w-field
                            label="{{'common.typeRespondentOther' | translate}}">
                            {{respondent?.typeOfPartyOther}}
                          </w-field>
                        }
                        <w-field label="{{'common.genderClaimant' | translate}}">
                          {{getGenderLabel(respondent?.gender)}}
                        </w-field>
                      </w-slot>
                    }
                  </w-section>
                }
                <!-- EDIT MODE -->
                @if (isEditingPartyAtIndex('respondent', i)) {
                  <w-section>
                      <w-slot>
                      <w-input-text [label]="'name' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondents[i].nameRespondent" [name]="'nameRespondent' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'nameRespondent'+i)">
                        @if (validName) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                        @if (ValidationName) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                      <!-- Identification Number (conditional based on office config and main party) -->
                      @if (officeDetails?.identificationNumberActive === 1 && isMainParty('respondent', i)) {
                        <w-input-text
                          [label]="'identificationNumber' | translate" [labelOnTop]="true"
                          [(ngModel)]="respondents[i].identificationNumberRespondent"
                          [name]="'identificationNumberRespondent' + i" [disabled]="readOnly">
                        </w-input-text>
                      }
                      @if (officeDetails?.prefixActive === 1 && isMainParty('respondent', i)) {
                        <w-input-text
                          [label]="'office.' + office +'.public.case.prefixRespondant' | translate" [labelOnTop]="true"
                          [(ngModel)]="respondents[i].prefixRespondent" [name]="'prefixRespondent' + i" [disabled]="readOnly"
                          (input)="insertData($event, 'prefixRespondent'+i)">
                          @if (validPrefix) {
                            <f-facet name="error">
                              {{'textLengthWarning' | translate: {value: '255'} }}
                            </f-facet>
                          }
                        </w-input-text>
                      }
                      <w-input-text [label]="(i === 0 ? 'office.' + office +'.public.case.respondingPartyAddress' : 'address') | translate" [labelOnTop]="true"
                        [(ngModel)]="respondents[i].addressRespondent" [name]="'addressRespondent' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'addressRespondent'+i)">
                        @if (validAddress) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-input-text [label]="'common.stateOrCountyRespondent' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondents[i].stateOrCountyRespondent" [name]="'stateOrCountyRespondent' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'stateOrCountyRespondent'+i)">
                        @if (validStateOrCounty) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-select-one [label]="'country' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondents[i].countryRespondantCode" [options]="optionsCountries"
                        [disabled]="readOnly">
                      </w-select-one>
                      <w-input-text [label]="'tel' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondents[i].telephoneRespondent" [name]="'telephoneRespondent' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                      <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                        [(ngModel)]="respondents[i].emailRespondent" [name]="'emailRespondent' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                      <!-- MAIN PARTY TYPE FIELDS (Index 0) -->
                      @if (isMainParty('respondent', i)) {
                        <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="respondents[i].typeRespondent" [options]="typeOfPartyOptions"
                          (change)="selectPartyTypeMain(respondents[i].typeRespondent, 'Respondent', i)"
                          [disabled]="readOnly">
                        </w-select-one>
                        <!-- DYNAMIC FIELD: Manager (shows when option 2 selected) -->
                        @if (shouldShowManagerMain('respondent', i)) {
                          <w-input-text
                            [label]="'common.managerRespondent' | translate" [labelOnTop]="true"
                            [(ngModel)]="respondents[i].managerRespondent" [name]="'managerRespondent' + i"
                            (input)="insertData($event, 'managerRespondent')">
                            @if (managerRespondentLengthError) {
                              <f-facet name="error">
                                {{'textLengthWarning' | translate: {value: '255'} }}
                              </f-facet>
                            }
                            @if (!validmanagerRespondent) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <!-- DYNAMIC FIELD: Type Other (shows when option 5 selected) -->
                        @if (shouldShowTypeOtherMain('respondent', i)) {
                          <w-input-text
                            [label]="'common.typeRespondentOther' | translate" [labelOnTop]="true"
                            [name]="'typeRespondentOther' + i" [(ngModel)]="respondents[i].typeRespondentOther"
                            (input)="insertData($event, 'typeRespondentOther')">
                            @if (!validTypeRespondentOther) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="respondents[i].genderRespondent" [options]="genderOptions" [disabled]="readOnly">
                        </w-select-one>
                      }
                      <!-- ADDITIONAL PARTY TYPE FIELDS (Index > 0) -->
                      @if (isAdditionalParty('respondent', i)) {
                        <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                          (change)="selectPartyTypeAdditional(respondents[i].typeOfParty, 'respondent', i)"
                          [(ngModel)]="respondents[i].typeOfParty" [options]="typeOfPartyOptions" [disabled]="readOnly">
                        </w-select-one>
                        <!-- DYNAMIC FIELD: Type Other (shows when option 5 selected) -->
                        @if (shouldShowTypeOtherAdditional('respondent', i)) {
                          <w-input-text
                            [label]="'common.typeRespondentOther' | translate" [labelOnTop]="true"
                            [name]="'typeOfPartyOtherResp' + i" [(ngModel)]="respondents[i].typeOfPartyOther"
                            (input)="insertData($event, 'typeOfPartyOther')">
                            @if (!validTypeOfPartyOther) {
                              <f-facet name="error">
                                {{'validationWarning' | translate }}
                              </f-facet>
                            }
                          </w-input-text>
                        }
                        <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                          [(ngModel)]="respondents[i].gender" [options]="genderOptions" [disabled]="readOnly">
                        </w-select-one>
                      }
                    </w-slot>
                    <w-slot>
                      @if (!readOnly) {
                        <div style="display:flex; justify-content: flex-end; gap: 10px; margin-top: 20px;"
                          >
                          <button w-button [label]="'cancel' | translate"
                            (click)="cancelEditPartyAtIndex('respondent', i)">
                          </button>
                          <button w-button [label]="'save' | translate" [isDefault]="true"
                            (click)="saveEditedPartyAtIndex('respondent', i)">
                          </button>
                        </div>
                      }
                    </w-slot>
                  </w-section>
                }
              </f-facet>
            </w-view-panel>
          }

          <!-- ADD RESPONDENT BUTTON -->
          @if (!isAddingParty('respondent') && !readOnly) {
            <button id="addRespondent" w-button [size]="'small'"
              (click)="startAddingParty('respondent')" [buttonType]="'text'" icon-start="add">
              {{'common.addParty' | translate}}
            </button>
          }

          <!-- ADD RESPONDENT FORM -->
          @if (isAddingParty('respondent')) {
            <w-edit-panel [hidden]="false">
              <f-facet name="actions">
                <button w-button (click)="cancelAddingParty('respondent')" style="margin-right: 10px;">{{'cancel' | translate}}</button>
                <button id="saveRespondent" w-button [isDefault]="true" (click)="saveNewParty('respondent')">
                  {{'save' | translate}}
                </button>
              </f-facet>
              <w-section>
                <w-slot>
                  <!-- NAME (Required) -->
                  <w-input-text [label]="'name' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.name"
                    name="newNameRespondent" (input)="insertData($event, 'newNameRespondent')">
                    @if (validName) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                    @if (ValidationName) {
                      <f-facet name="error">
                        {{'validationWarning' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="(respondents.length === 0 ? 'office.' + office +'.public.case.respondingPartyAddress' : 'address') | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.address"
                    name="newAddressRespondent" (input)="countCharsValNew('address')">
                    @if (validAddress) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'common.stateOrCountyRespondent' | translate" [labelOnTop]="true"
                    [(ngModel)]="newPartyData.stateOrCounty" name="newStateRespondent"
                    (input)="countCharsValNew('stateOrCounty')">
                    @if (validStateOrCounty) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-select-one [label]="'country' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.countryCode"
                    [options]="optionsCountries">
                  </w-select-one>
                  <w-input-text [label]="'tel' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.telephone"
                    name="newTelRespondent">
                  </w-input-text>
                  <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                    [(ngModel)]="newPartyData.email" name="newEmailRespondent" (wKeyup)="onEmailValidNew()">
                    @if (invalidEmailsValidation) {
                      <f-facet name="error">
                        {{'validationEmail' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                  <!-- FOR MAIN PARTY (First Respondent) -->
                  @if (respondents.length === 0) {
                    <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                      (change)="selectPartyTypeForNewMain(newPartyData.typeRespondent, 'Respondent')"
                      [(ngModel)]="newPartyData.typeRespondent" [options]="typeOfPartyOptions">
                    </w-select-one>
                    <!-- DYNAMIC FIELD: Manager (shows when option 2 - Company is selected) -->
                    @if (managerRespondentField) {
                      <w-input-text [label]="'common.managerRespondent' | translate"
                        [labelOnTop]="true" [(ngModel)]="newPartyData.managerRespondent" name="newmanagerRespondent"
                        (input)="insertData($event, 'managerRespondent')">
                        @if (managerRespondentLengthError) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                        @if (!validmanagerRespondent) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <!-- DYNAMIC FIELD: Type Other (shows when option 5 - Other is selected) -->
                    @if (displaytypeRespondentOtherField) {
                      <w-input-text
                        [label]="'common.typeRespondentOther' | translate" [labelOnTop]="true" name="newtypeRespondentOther"
                        [(ngModel)]="newPartyData.typeRespondentOther" (input)="insertData($event, 'typeRespondentOther')">
                        @if (!validTypeRespondentOther) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                      [(ngModel)]="newPartyData.genderRespondent" [options]="genderOptions">
                    </w-select-one>
                  }
                  <!-- FOR ADDITIONAL PARTY (Second+ Respondent) -->
                  @if (respondents.length > 0) {
                    <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true"
                      (change)="selectPartyTypeForNewAdditional(newPartyData.typeOfParty)"
                      [(ngModel)]="newPartyData.typeOfParty" [options]="typeOfPartyOptions">
                    </w-select-one>
                    <!-- DYNAMIC FIELD: Type Other (shows when option 5 - Other is selected) -->
                    @if (displayTypeOfPartyOtherField) {
                      <w-input-text [label]="'common.typeRespondentOther' | translate"
                        [labelOnTop]="true" name="newtypeOfPartyOtherResp" [(ngModel)]="newPartyData.typeOfPartyOther"
                        (input)="insertData($event, 'typeOfPartyOther')">
                        @if (!validTypeOfPartyOther) {
                          <f-facet name="error">
                            {{'validationWarning' | translate }}
                          </f-facet>
                        }
                      </w-input-text>
                    }
                    <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true"
                      [(ngModel)]="newPartyData.gender" [options]="genderOptions">
                    </w-select-one>
                  }
                </w-slot>
              </w-section>
            </w-edit-panel>
                    }
        </div>
      </div>
    </div>

    <!-- ========== REPRESENTATIVES - SIDE BY SIDE ========== -->
    <div class="row clearfix">
      <div class="column-left">
        <!-- ============ REQUESTING PARTY REPRESENTATIVE ============ -->
        <div>
          <w-edit-panel style="height: 24px;">
            <w-section>
              <f-facet name="header" id="headerReqPartyRep">
                {{'office.cases.requestingPartyRepresent' | translate}}
              </f-facet>
            </w-section>
          </w-edit-panel>

          <!-- CLAIMANT REPRESENTATIVE LIST -->
          @for (claimantRep of claimantRepBys; track claimantRep; let i = $index) {
            <w-view-panel [reviewMode]="false" [folded]="!isAccordionOpen('claimantRepBy', i)"
              (wFoldedChange)="onAccordionToggle('claimantRepBy', i, !$event)">
              <f-facet name="primary-action">
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="toggleEditPartyAtIndex('claimantRepBy', i, $event)" [buttonType]="'edit'">
                  </button>
                }
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="deletePartyAtIndex('claimantRepBy', i)" [buttonType]="'delete'">
                  </button>
                }
              </f-facet>
              <!-- FOLDED VIEW -->
              <f-facet name="section-folded">
                <w-section>
                  <w-slot>
                    <w-field label="{{'name' | translate}}">
                      {{claimantRep?.nameClaimantRepBy}}
                    </w-field>
                  </w-slot>
                  <w-slot>
                    <w-field label="{{'tel' | translate}}">
                      {{claimantRep?.telephoneClaimantRepBy}}
                    </w-field>
                  </w-slot>
                  @if (claimantRep?.emailClaimantRepBy) {
                    <w-slot>
                      <w-field label="{{'email' | translate}}">
                        {{claimantRep?.emailClaimantRepBy}}
                      </w-field>
                    </w-slot>
                  }
                </w-section>
              </f-facet>
              <!-- UNFOLDED VIEW -->
              <f-facet name="section-unfolded">
                <!-- VIEW MODE -->
                @if (!isEditingPartyAtIndex('claimantRepBy', i)) {
                  <w-section>
                    <w-slot>
                      <w-field label="{{'name' | translate}}">
                        {{claimantRep?.nameClaimantRepBy}}
                      </w-field>
                      <w-field label="{{'address' | translate}}">
                        {{claimantRep?.addressClaimantRepBy}}
                      </w-field>
                      <w-field label="{{'common.stateOrCountyClaimantRepBy' | translate}}">
                        {{claimantRep?.stateOrCountyClaimantRepBy}}
                      </w-field>
                      <w-field label="{{'country' | translate}}">
                        {{claimantRep?.countryClaimantRepBy}}
                      </w-field>
                      <w-field label="{{'tel' | translate}}">
                        {{claimantRep?.telephoneClaimantRepBy}}
                      </w-field>
                      <w-field label="{{'email' | translate}}">
                        {{claimantRep?.emailClaimantRepBy}}
                      </w-field>
                    </w-slot>
                  </w-section>
                }
                <!-- EDIT MODE -->
                @if (isEditingPartyAtIndex('claimantRepBy', i)) {
                  <w-section>
                    <w-slot>
                      <w-input-text [label]="'name' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimantRepBys[i].nameClaimantRepBy" [name]="'nameClaimantRepBy' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                      <w-input-text [label]="'address' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimantRepBys[i].addressClaimantRepBy" [name]="'addressClaimantRepBy' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'addressClaimantRepBy'+i)">
                        @if (validAddress) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-input-text [label]="'common.stateOrCountyClaimantRepBy' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimantRepBys[i].stateOrCountyClaimantRepBy"
                        [name]="'stateOrCountyClaimantRepBy' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'stateOrCountyClaimantRepBy'+i)">
                        @if (validStateOrCounty) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-select-one [label]="'country' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimantRepBys[i].countryClaimantRepByCode" [options]="optionsCountries"
                        [disabled]="readOnly">
                      </w-select-one>
                      <w-input-text [label]="'tel' | translate" [labelOnTop]="true"
                        [(ngModel)]="claimantRepBys[i].telephoneClaimantRepBy" [name]="'telephoneClaimantRepBy' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                      <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                        [(ngModel)]="claimantRepBys[i].emailClaimantRepBy" [name]="'emailClaimantRepBy' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                    </w-slot>
                    <w-slot>
                      @if (!readOnly) {
                        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;"
                          >
                          <button w-button [label]="'cancel' | translate"
                            (click)="cancelEditPartyAtIndex('claimantRepBy', i)">
                          </button>
                          <button w-button [label]="'save' | translate" [isDefault]="true"
                            (click)="saveEditedPartyAtIndex('claimantRepBy', i)">
                          </button>
                        </div>
                      }
                    </w-slot>
                  </w-section>
                }
              </f-facet>
            </w-view-panel>
          }

          <!-- ADD CLAIMANT REPRESENTATIVE BUTTON -->
          @if (!isAddingParty('claimantRepBy') && !readOnly && canAddRepresentative('claimantRepBy')) {
            <button
              id="addClaimantRep" w-button [size]="'small'" (click)="startAddingParty('claimantRepBy')"
              [buttonType]="'text'" icon-start="add">
              {{'common.addParty' | translate}}
            </button>
          }

          <!-- ADD CLAIMANT REPRESENTATIVE FORM -->
          @if (isAddingParty('claimantRepBy')) {
            <w-edit-panel [hidden]="false">
              <f-facet name="actions">
                <button w-button (click)="cancelAddingParty('claimantRepBy')" style="margin-right: 10px;">
                  {{'cancel' | translate}}
                </button>
                <button id="saveClaimantRep" w-button [isDefault]="true" (click)="saveNewParty('claimantRepBy')">
                  {{'save' | translate}}
                </button>
              </f-facet>
              <w-section>
                <w-slot>
                  <w-input-text [label]="'name' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.name"
                    name="newNameClaimantRep" (input)="countCharsValNew('name')">
                    @if (validName) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                    @if (ValidationName) {
                      <f-facet name="error">
                        {{'validationWarning' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'address' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.address"
                    name="newAddressClaimantRep" (input)="countCharsValNew('address')">
                    @if (validAddress) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'common.stateOrCountyClaimantRepBy' | translate" [labelOnTop]="true"
                    [(ngModel)]="newPartyData.stateOrCounty" name="newStateClaimantRep"
                    (input)="countCharsValNew('stateOrCounty')">
                    @if (validStateOrCounty) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-select-one [label]="'country' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.countryCode"
                    [options]="optionsCountries">
                  </w-select-one>
                  <w-input-text [label]="'tel' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.telephone"
                    name="newTelClaimantRep">
                  </w-input-text>
                  <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                    [(ngModel)]="newPartyData.email" name="newEmailClaimantRep" (wKeyup)="onEmailValidNew()">
                    @if (invalidEmailsValidation) {
                      <f-facet name="error">
                        {{'validationEmail' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                </w-slot>
              </w-section>
            </w-edit-panel>
                    }
        </div>
      </div>

      <div class="column-right">
        <!-- ============ RESPONDING PARTY REPRESENTATIVE ============ -->
        <div>
          <w-edit-panel style="height: 24px;">
            <w-section>
              <f-facet name="header" id="headerRespPartyRep">
                {{'office.cases.respondingPartyRepresent' | translate}}
              </f-facet>
            </w-section>
          </w-edit-panel>

          <!-- RESPONDENT REPRESENTATIVE LIST -->
          @for (respondentRep of respondentRepBys; track respondentRep; let i = $index) {
            <w-view-panel [reviewMode]="false" [folded]="!isAccordionOpen('respondentRepBy', i)"
              (wFoldedChange)="onAccordionToggle('respondentRepBy', i, !$event)">
              <f-facet name="primary-action">
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="toggleEditPartyAtIndex('respondentRepBy', i, $event)" [buttonType]="'edit'">
                  </button>
                }
                @if (!readOnly) {
                  <button w-button [label]="'%1'" [size]="'medium'"
                    (click)="deletePartyAtIndex('respondentRepBy', i)" [buttonType]="'delete'">
                  </button>
                }
              </f-facet>
              <!-- FOLDED VIEW -->
              <f-facet name="section-folded">
                <w-section>
                  <w-slot>
                    <w-field label="{{'name' | translate}}">
                      {{respondentRep?.nameRespondentRepBy}}
                    </w-field>
                  </w-slot>
                  <w-slot>
                    <w-field label="{{'tel' | translate}}">
                      {{respondentRep?.telephoneRespondentRepBy}}
                    </w-field>
                  </w-slot>
                  @if (respondentRep?.emailRespondentRepBy) {
                    <w-slot>
                      <w-field label="{{'email' | translate}}">
                        {{respondentRep?.emailRespondentRepBy}}
                      </w-field>
                    </w-slot>
                  }
                </w-section>
              </f-facet>
              <!-- UNFOLDED VIEW -->
              <f-facet name="section-unfolded">
                <!-- VIEW MODE -->
                @if (!isEditingPartyAtIndex('respondentRepBy', i)) {
                  <w-section>
                    <w-slot>
                      <w-field label="{{'name' | translate}}">
                        {{respondentRep?.nameRespondentRepBy}}
                      </w-field>
                      <w-field label="{{'address' | translate}}">
                        {{respondentRep?.addressRespondentRepBy}}
                      </w-field>
                      <w-field label="{{'common.stateOrCountyRespondentRepBy' | translate}}">
                        {{respondentRep?.stateOrCountyRespondentRepBy}}
                      </w-field>
                      <w-field label="{{'country' | translate}}">
                        {{respondentRep?.countryRespondentRepBy}}
                      </w-field>
                      <w-field label="{{'tel' | translate}}">
                        {{respondentRep?.telephoneRespondentRepBy}}
                      </w-field>
                      <w-field label="{{'email' | translate}}">
                        {{respondentRep?.emailRespondentRepBy}}
                      </w-field>
                    </w-slot>
                  </w-section>
                }
                <!-- EDIT MODE -->
                @if (isEditingPartyAtIndex('respondentRepBy', i)) {
                  <w-section>
                    <w-slot>
                      <w-input-text [label]="'name' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondentRepBys[i].nameRespondentRepBy" [name]="'nameRespondentRepBy' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                      <w-input-text [label]="'address' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondentRepBys[i].addressRespondentRepBy" [name]="'addressRespondentRepBy' + i"
                        [disabled]="readOnly" (input)="insertData($event, 'addressRespondentRepBy'+i)">
                        @if (validAddress) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-input-text [label]="'common.stateOrCountyRespondentRepBy' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondentRepBys[i].stateOrCountyRespondentRepBy"
                        [name]="'stateOrCountyRespondentRepBy' + i" [disabled]="readOnly"
                        (input)="insertData($event, 'stateOrCountyRespondentRepBy'+i)">
                        @if (validStateOrCounty) {
                          <f-facet name="error">
                            {{'textLengthWarning' | translate: {value: '255'} }}
                          </f-facet>
                        }
                      </w-input-text>
                      <w-select-one [label]="'country' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondentRepBys[i].countryRespondantRepByCode" [options]="optionsCountries"
                        [disabled]="readOnly">
                      </w-select-one>
                      <w-input-text [label]="'tel' | translate" [labelOnTop]="true"
                        [(ngModel)]="respondentRepBys[i].telephoneRespondentRepBy"
                        [name]="'telephoneRespondentRepBy' + i" [disabled]="readOnly">
                      </w-input-text>
                      <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                        [(ngModel)]="respondentRepBys[i].emailRespondentRepBy" [name]="'emailRespondentRepBy' + i"
                        [disabled]="readOnly">
                      </w-input-text>
                    </w-slot>
                    <w-slot>
                      @if (!readOnly) {
                        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;"
                          >
                          <button w-button [label]="'cancel' | translate"
                            (click)="cancelEditPartyAtIndex('respondentRepBy', i)">
                          </button>
                          <button w-button [label]="'save' | translate" [isDefault]="true"
                            (click)="saveEditedPartyAtIndex('respondentRepBy', i)">
                          </button>
                        </div>
                      }
                    </w-slot>
                  </w-section>
                }
              </f-facet>
            </w-view-panel>
          }

          <!-- ADD RESPONDENT REPRESENTATIVE BUTTON -->
          @if (!isAddingParty('respondentRepBy') && !readOnly && canAddRepresentative('respondentRepBy')) {
            <button
              id="addRespondentRep" w-button [size]="'small'" (click)="startAddingParty('respondentRepBy')"
              [buttonType]="'text'" icon-start="add">
              {{'common.addParty' | translate}}
            </button>
          }

          <!-- ADD RESPONDENT REPRESENTATIVE FORM -->
          @if (isAddingParty('respondentRepBy')) {
            <w-edit-panel [hidden]="false">
              <f-facet name="actions">
                <button w-button (click)="cancelAddingParty('respondentRepBy')" style="margin-right: 10px;">{{'cancel' | translate}} </button>
                <button id="saveRespondentRep" w-button [isDefault]="true" (click)="saveNewParty('respondentRepBy')">
                  {{'save' | translate}}
                </button>
              </f-facet>
              <w-section>
                <w-slot>
                  <w-input-text [label]="'name' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.name"
                    name="newNameRespondentRep" (input)="countCharsValNew('name')">
                    @if (validName) {
                      <f-facet name="error"> {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                    @if (ValidationName) {
                      <f-facet name="error">{{'validationWarning' | translate }} </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'address' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.address"
                    name="newAddressRespondentRep" (input)="countCharsValNew('address')">
                    @if (validAddress) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-input-text [label]="'common.stateOrCountyRespondentRepBy' | translate" [labelOnTop]="true"
                    [(ngModel)]="newPartyData.stateOrCounty" name="newStateRespondentRep"
                    (input)="countCharsValNew('stateOrCounty')">
                    @if (validStateOrCounty) {
                      <f-facet name="error">
                        {{'textLengthWarning' | translate: {value: '255'} }}
                      </f-facet>
                    }
                  </w-input-text>
                  <w-select-one [label]="'country' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.countryCode"
                    name="newCountryRespondentRep" [options]="optionsCountries">
                  </w-select-one>
                  <w-input-text [label]="'tel' | translate" [labelOnTop]="true" [(ngModel)]="newPartyData.telephone"
                    name="newTelRespondentRep">
                  </w-input-text>
                  <w-input-text [label]="'email' | translate" [labelOnTop]="true" [type]="'email'"
                    [(ngModel)]="newPartyData.email" name="newEmailRespondentRep" (wKeyup)="onEmailValidNew()">
                    @if (invalidEmailsValidation) {
                      <f-facet name="error">
                        {{'validationEmail' | translate }}
                      </f-facet>
                    }
                  </w-input-text>
                </w-slot>
                            </w-section>
            </w-edit-panel>
          }
        </div>
      </div>
    </div>

  </f-facet>

</w-step>

<div style="height:100px;">&nbsp;</div>